import { qrcode } from "@libs/qrcode";

import { WifiNetwork } from "../../../casts/wifi-network";
import { CloseIcon } from "../../../components/icons";
import { createWifiQrCode } from "../../../helpers/qr-code";

export default function WifiQrModal(props: {
  wifi: WifiNetwork;
  onClose: () => void;
}) {
  return (
    <div class="modal modal-open" onClick={props.onClose}>
      <div
        class="modal-box max-w-sm md:max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-xl font-bold">Scan to Connect</h2>
          <button
            class="btn btn-ghost btn-circle btn-sm"
            onClick={props.onClose}
          >
            <CloseIcon />
          </button>
        </div>
        <div class="flex justify-center mb-4">
          <div
            innerHTML={qrcode(
              createWifiQrCode({
                ssid: props.wifi.ssid,
                password: props.wifi.password,
                hidden: props.wifi.hidden,
              }),
              {
                output: "svg",
                dark: "#000000",
                light: "#ffffff",
                ecl: "MEDIUM",
              },
            )}
          />
        </div>
        <p class="text-center text-sm text-base-content/70">
          Scan this QR code with your device's camera to connect to "
          {props.wifi.ssid}"
        </p>
      </div>
    </div>
  );
}
